module.exports = __webpack_public_path__ + "img/c2.64668209.png";